module.exports = __webpack_public_path__ + "static/media/iphone-new-shift.189b084e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/iphone-new-shift.png
// module id = 1423
// module chunks = 0